import styled from '@emotion/styled';
import type { FunctionComponent } from 'react';

const StyledRequiredMark = styled.span({
    color: '#ff0004',
    fontFamily: 'FT Regola Neue',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
    marginLeft: '0.125rem',
    wordWrap: 'break-word',
});

export const RequiredMark: FunctionComponent = () => <StyledRequiredMark>*</StyledRequiredMark>;
